import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconColumns = props => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path d="M14.67 5v14H9.33V5h5.34zm1 14H21V5h-5.33v14zm-7.34 0V5H3v14h5.33z" />
  </SvgIcon>
);

export default IconColumns;



// WEBPACK FOOTER //
// ./src/components/icons/IconColumns.js